import React, { useState, useEffect } from "react";
import useMediaQuery from "../../utils/media-query";

const ExpandableSectionV2 = ({
  heroBanner,
  children,
  defaultExpanded = true,
  disableCollapse = false,
  loading = false,
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);
  const isMobile = useMediaQuery("(max-width: 768px)");

  useEffect(() => {
    if (disableCollapse) {
      setIsExpanded(true);
    }
  }, [disableCollapse]);

  if (loading) {
    return null;
  }

  const toggleExpanded = () => {
    if (!disableCollapse) {
      setIsExpanded(!isExpanded);
    }
  };

  return (
    <section className="bg-white rounded-xl shadow-lg overflow-hidden">
      <div className="relative isolate">
        <div
          className={`${
            isMobile && !disableCollapse ? "cursor-pointer" : ""
          } relative z-10`}
          onClick={isMobile ? toggleExpanded : undefined}
        >
          {heroBanner}
        </div>
        {!disableCollapse && (
          <button
            onClick={toggleExpanded}
            className="absolute top-1/2 right-4 -translate-y-1/2 z-30
            w-10 h-10
            rounded-full
            bg-white/10
            backdrop-blur-sm
            border border-white/10
            shadow-[0_0_0_1px_rgba(255,255,255,0.15)]
            flex items-center justify-center
            transition-all duration-300"
            aria-label="Toggle details"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              className={`transition-transform duration-300 ${
                isExpanded ? "" : "rotate-180"
              }`}
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 17V7"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M8 11L12 7L16 11"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        )}
      </div>

      {isExpanded && (
        <div className="w-full p-3 md:px-6 md:py-4 transition-all duration-300 ease-in-out">
          {children}
        </div>
      )}
    </section>
  );
};

export default ExpandableSectionV2;
